import julianPic from "@/public/images/artists/julian.png";
import { Artist } from "@/types/types";

export const julian = {
  id: "245",
  name: "Julian",
  image: julianPic,
  description: `Julian's voice is a light, melodic tenor with a smooth pop-R&B character. He moves easily between smooth mid-range notes and a bright, controlled falsetto, often decorating phrases with clean, precise runs and gentle vibrato.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjulian-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "Dance", "Unprocessed", "RnB"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 47,
        high: 69,
      },
      sweetSpot: 59,
    },
  },
} as const satisfies Artist;
